import React, {useMemo, useState} from "react";
import ReactTable from "react-table-v6"
import { ArrowForward } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

import { AddCircle } from "@mui/icons-material";
import { IconButton } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import 'react-table-v6/react-table.css'

const BuildingList = (props) => {
    const buildingAddPath = useMemo(() => {
        const params = new URLSearchParams();
        if (props.siteId) {
            params.set("site_id", props.siteId);
        }
        const search = params.toString()
        return { pathname: "/buildings/add", search };
    }, [props.siteId]);

    let history = useHistory();

    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (!props.buildings)  return null;
    const columns = [
        {
            Header: 'Location',
            accessor: 'site_name',
            style: {paddingTop: 15},
            Cell: p => {
                return p.value;
            },
            show: width > 1000
        },
        {
            Header: 'Name',
            accessor: 'name',
            style: {paddingTop: 15}
        },
        {
            Header: 'Floors',
            accessor: 'floors',
            style: {paddingTop: 15}
        },
        {
            Header: '',
            accessor: 'id',
            Cell: p => {
                let link = "/buildings/" + p.value

                return <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"View building detail" }
                            size={"small"}
                            onClick={() => {
                                        history.push(link)
                                }}>
                            <ArrowForward />
                        </IconButton>
            },
            width: 50
        },
    ]



        return (
            <div className="space-list">
                <div className="space-add-mode">
                {
                    props.buildings && props.buildings.length ?
                    <Tooltip title="Add Buildings">
                        <IconButton
                                    variant="contained"
                                    color="primary"
                                    aria-label={"Add buildings" }

                                    onClick={() => {
                                        history.push(buildingAddPath)
                                }}>
                                    <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.0)"}}/>
                        </IconButton>
                    </Tooltip> : null }
                </div>
                <div className="section-header">Buildings </div>
                {
                    props.buildings && props.buildings.length ?
                    <div className="point-list-table">
                    <ReactTable key={(props.buildings && props.buildings.length) || 0}
                        data={props.buildings || []}
                        columns={columns}
                        minRows={0}
                        defaultPageSize={10}
                        showPagination={props.buildings && props.buildings.length > 10}
                    />
                    </div>:
                    <div className="bulk_add_prompt">
                        <IconButton
                                    variant="contained"
                                    color="primary"
                                    aria-label={"Add buildings" }

                                    onClick={() => {
                                        history.push(buildingAddPath)
                                }}>
                                <AddCircle style={{fill: "#00b088", background: "white"}}/>
                        </IconButton>
                        There are currently no buildings configured.  Add some now!
                    </div>
                }
            </div>
        )
}

export default BuildingList;
